import { withFeatureFlagService } from '@mews/framework';
import connectMessagesApp from './connectMessagesApp';
import MessagesApp from './MessagesApp';

export default withFeatureFlagService(connectMessagesApp(MessagesApp));
